import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  fetchFooterLeft,
  fetchFooterMiddle,
  fetchFooterRight,
  fetchMenuLeft,
  fetchMenuRight,
  footerLeftSelector,
  footerMiddleSelector,
  footerRightSelector,
  menuLeftSelector,
  menuRightSelector,
} from '../../entities/ProjectSlice';

export const useMenuService = () => {
  const dispatch = useDispatch();
  const menuLeft = useSelector(menuLeftSelector);
  const menuRight = useSelector(menuRightSelector);
  const footerLeft = useSelector(footerLeftSelector);
  const footerMiddle = useSelector(footerMiddleSelector);
  const footerRight = useSelector(footerRightSelector);

  useEffect(() => {
    if (!footerRight) dispatch(fetchFooterRight());
  }, [footerRight]);

  useEffect(() => {
    if (!footerLeft) dispatch(fetchFooterLeft());
  }, [footerLeft]);

  useEffect(() => {
    if (!footerMiddle) dispatch(fetchFooterMiddle());
  }, [footerMiddle]);

  useEffect(() => {
    if (!menuRight) dispatch(fetchMenuRight());
  }, [menuRight]);

  useEffect(() => {
    if (!menuLeft) dispatch(fetchMenuLeft());
  }, [menuLeft]);

  return {
    menuLeft,
    menuRight,
    footerLeft,
    footerMiddle,
    footerRight,
  };
};
